import { Model } from './model';
import { Association } from './association';

export class Module extends Model {
  id: number;
  name: string;

  constructor(values: Object = {}) {
    super(values);
  }
}

export class Profile extends Model {
  old_password: string;
  new_password: string;
  repeat_password: string;

  ship_owner: Object;
  modules: Module[];

  currentAssociation: number;

  public static apiMap(values: Object = {}) {
    if (!values) {
      return new Profile();
    }

    if (values['modules']) {
      values['modules'] = values['modules'].map(function (moduleData) {
        return new Module(moduleData);
      });
    }

    return new Profile(values);
  }

  constructor(values: Object = {}) {
    super(values);
  }

  haveAccess(module_name) {
    let sw = false;
    if (!this.modules) {
      return sw;
    }

    for (const module of this.modules) {
      if (module.name === module_name) {
        sw = true;
        return sw;
      }
    }
    return sw;
  }

  isShipOwner() {
    return !!this.ship_owner;
  }
}



// WEBPACK FOOTER //
// ./src/app/_models/profile.ts